import React from 'react'

const Blog4banner = () => {
  return (
    <>
     <section className="tf-slider blog4  parallax">
            <div className="content"></div>
            <div className="container ">
                <div className="row ">
                    <div className="col-lg-12">
                        {/* <FormContent /> */}
                    </div>
                </div>
            </div>
            <div className="overlay"></div>
        </section>
    </>
  )
}

export default Blog4banner